export const STATUS_LABELS = {
  demande_recue: "Demande reçue",
  informations_manquantes: "Informations manquantes",
  a_valider: "À valider par Charbonier Studio",
  devis_en_preparation: "Devis en préparation",
  devis_envoye: "Devis envoyé",
  devis_accepte: "Devis accepté",
  devis_refuse: "Devis refusé",
  devis_expire: "Devis expiré",
  attente_accord_client: "En attente d'accord client",
  attente_paiement: "En attente de paiement",
  attente_acompte: "En attente d'acompte",
  acompte_recu: "Acompte reçu",
  paiement_intermediaire_a_regler: "Règlement intermédiaire à régler",
  paiement_intermediaire_recu: "Règlement intermédiaire reçu",
  solde_a_regler: "Solde à régler",
  paiement_recu: "Paiement reçu",
  paiement_echoue: "Paiement échoué",
  paiement_annule: "Paiement annulé",
  rembourse: "Remboursé",
  en_cours: "En cours de réalisation",
  bat_envoye: "BAT envoyé",
  bat_valide: "BAT validé",
  attente_validation: "En attente de validation",
  corrections_demandees: "Corrections demandées",
  finalisation: "Finalisation",
  termine: "Terminé",
  annule: "Annulé",
};

export const STATUS_LIST = Object.keys(STATUS_LABELS);

export const CATEGORIES = [
  { slug: "prepresse", label: "Print & prépresse", short: "Prépresse", eyebrow: "01 / Prépresse",
    description: "Analyse, correction, adaptation et contrôle de vos fichiers pour l'imprimeur." },
  { slug: "creation", label: "Création print", short: "Création", eyebrow: "02 / Création",
    description: "Cartes, flyers, affiches, marque-pages, invitations, réglettes, fiches et supports sur-mesure." },
  { slug: "edition", label: "Mise en page & édition", short: "Édition", eyebrow: "03 / Édition",
    description: "Livres, livrets, brochures, magazines et documents éditoriaux mis en page proprement." },
  { slug: "couvertures", label: "Couvertures de livres", short: "Couvertures", eyebrow: "04 / Couvertures",
    description: "Première seule ou couverture complète prête imprimeur — dos calé, ISBN, code-barres." },
  { slug: "image", label: "Image & retouche", short: "Image", eyebrow: "05 / Image",
    description: "Restauration, retouche complexe, photomontage — pour l'impression HD." },
];

export const eur = (n) => new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);
